import { render } from "./SelectBets.vue?vue&type=template&id=0a3a8b90"
import script from "./SelectBets.vue?vue&type=script&lang=js"
export * from "./SelectBets.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__